import { configureStore } from "@reduxjs/toolkit";
import loginSlice from "./slices/loginSLice";
import popUpSlice from "./slices/popUpSlice";
import userSlice from "./slices/userSlice";
import controlServiceSlice from "./slices/controlServiceSlice";
import headerSlice from "./slices/headerSlice";
import bellNotificationSlice from "./slices/bellNotificationSlice";

const store = configureStore({
  reducer: {
    login: loginSlice,
    popUp: popUpSlice,
    userData: userSlice,
    controlService: controlServiceSlice,
    header: headerSlice,
    bellNotification: bellNotificationSlice,
  },
});

export default store;
